/*========================================================================
* $Id: clientnotification.js -1M 2016-03-11 18:13:13Z (local) $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2024
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "client/template",
  "utils/browser",
  "client/resourceinfo",
  "component!base",
  "i18n/i18n",
  "jquery",
  "underscore",
  "api/v1/mindbreeze/client/notification",
  "utils/clientnotification",
  "utils/url"
 ], function(
   Template,
   Browser,
   ResourceInfo,
   Base,
   i18n,
   $,
   _,
   NotificationChannel,
   ClientNotificationUtil,
   url
 ) {
      Browser.loadCSS(ResourceInfo.scriptLocation + "../client/component/clientnotification/css/clientnotification.css", "clientnotification");

      var clientnotificationJsonData = [];
      var clientnotificationStyle = {};
      var clientnotificationGeneralConfig = {};

      var DELAY_SHOW_NEXT_INFO_SCREEN = 1500;
      var PREVIEW_INFO_SCREEN_QUERY_PARAM_NAME = 'previewClientNotificationId';
      var ACTION_NAME = "client_notification";

      var ClientNotificationCollection =  new NotificationChannel.NotificationCollection();
      var app = {};

      var ClientNotificationTemplate = Template.extend({
        initialize: function () {
          Template.prototype.initialize.apply(this, _.toArray(arguments));
            app = this.application; 
        },

        createView: function(options) {
          return Template.prototype.createView.apply(this, [options]);
        }
      });

      ClientNotificationTemplate.beforeTemplateTreeInitialization = function (rootEls, application) {
         // prevent add clientnotification in sub-applicaction - only main app can have clientnotification added to dom
         if($(rootEls).find('div[data-template="clientnotification"]').length <= 0 && application && !application.parentApplication) {
           $(rootEls).append('<div data-template="clientnotification" class="clientnotification"></div>');
         }
      };

      
      ClientNotificationTemplate.View = Base.extend({
        initialize: function () {
          this.currIndex = 0;
          this.clientnotificationIsOpen = false;
          var disabledClientNotifications = (app && app.options.disableClientNotifications);
          if (!disabledClientNotifications) {
            var addClientNotificationJsonToCollection = this.addClientNotificationJsonToCollection.bind(this);
            ClientNotificationCollection.on("add",addClientNotificationJsonToCollection);
            var getClientNotificationConfigJson = this.getClientNotificationConfigJson.bind(this);
            app.listenTo(app, "afterApplicationCallback", getClientNotificationConfigJson, this); 
          }
        },

         addClientNotificationJsonToCollection: function(ClientNotificationCollection) {
          if (ClientNotificationCollection.attributes) {
            if (ClientNotificationCollection.attributes.items) {
              clientnotificationJsonData = ClientNotificationCollection.attributes.items;
            }
  
            if (ClientNotificationCollection.attributes.theme) {
              clientnotificationStyle = ClientNotificationCollection.attributes.theme;
            }
  
            if (ClientNotificationCollection.attributes.general_config) {
              clientnotificationGeneralConfig = ClientNotificationCollection.attributes.general_config;
            }
  
            var previewClientNotificationId = url.getQueryParam(window.location.href, PREVIEW_INFO_SCREEN_QUERY_PARAM_NAME);
  
            if (clientnotificationGeneralConfig.enable_all_notifications || previewClientNotificationId) {
              var view = new ClientNotificationTemplate.View();
              view.appendClientNotification();
            }
          }
        },  

         getClientNotificationConfigJson: function () {
          const isChromiumBrowserExtension = Browser.getURLParameter('searchRequestName') === 'Browser-Plugin';
  
          var disabledClientNotifications = (app && app.options.disableClientNotifications);
  
          if(disabledClientNotifications || Browser.isOutlook() || Browser.isIosApp() || isChromiumBrowserExtension || Mindbreeze.isEditorBundle) {
            return;
          }

          var apiLocation = this.apiLocation.bind(this);

          setTimeout(function() {
            ClientNotificationCollection.fetch(apiLocation(), app.options, app.channelOptions);
          }, 3000)
         
        },

        apiLocation: function() {
          var primaryChannelUrl = '';
          if (app.models.channels.at(0) && app.models.channels.at(0).get('url')) {
            primaryChannelUrl = app.models.channels.at(0).get('url');
          }
  
          return primaryChannelUrl;
        },

        isDifferentOrigin: function(link) {
          var parser = document.createElement('a');
          parser.href = link;
          var linkOrigin = parser.origin;
          var currentOrigin = window.location.origin;
          return linkOrigin !== currentOrigin;
        },

        checkFileAvailability: function(url) {
          var that = this;
          return fetch(url, { method: 'GET' })
          .then(function(response) {
            if (response.status === 200) {
              return true;
            } else {
              return false;
            }
          })
          .catch(function(error) {
            if(that.isDifferentOrigin(url)) {
              return true;
            } else {
              return false;
            }
          });
        },

        appendClientNotification: function() {
          if (this.currIndex >= clientnotificationJsonData.length) {
            return;
          }

          this.$clientnotification = $('[data-template="clientnotification"] :first-child');
          this.$clientnotification.removeClass('show');
          this.clientNotificationContentJson = clientnotificationJsonData[this.currIndex];
          var href = this.clientNotificationContentJson.client_notification_actions[0].href;
          var precheckUrl = this.clientNotificationContentJson.client_notification_actions[0].precheck_url;
          this.checkFileAvailability(ClientNotificationUtil.handleHref(this.apiLocation(), precheckUrl || href))
          .then(function(isFileAvailable) {
            if (
              !isFileAvailable ||
              !ClientNotificationUtil.canDisplayClientNotification(this.clientNotificationContentJson)
            ) {
              this.goToNext();
              return;
            } else {
              app.trigger("actionperformed", ACTION_NAME + "_show", {"application": app,
                                                            "args": app.args,
                                                            "comment": this.clientNotificationContentJson.client_notification_type,
                                                            "model": {},
                                                            "handlerExists": app.handlerExists,
                                                            "returnValue": app.returnValue,
                                                            "error": app.error });

              var actionType = this.clientNotificationContentJson.client_notification_actions[0].action;

              var htmlContent = ''+
                '<div class="mb-clientnotification small-screen show">'+
                  '<div class="mb-clientnotification-container">'+
                    '<div class="mb-clientnotification-content-section">'+
                    '<h4 class="clientnotification-heading">'+ ClientNotificationUtil.getTextForLanguage(this.clientNotificationContentJson.client_notification_content.title) +'</h4>'+
                    '<p class="clientnotification-text">'+ ClientNotificationUtil.getTextForLanguage(this.clientNotificationContentJson.client_notification_content.preview_text_description) +'</p>'+
                    '</div>'+
                    '<div class="mb-clientnotification-button-section">'+
                      '<button class="mb-clientnotification-button mb-clientnotification-button-primary">'+ ClientNotificationUtil.getTextForLanguage(this.clientNotificationContentJson.client_notification_actions[0].label)+'</button>'+
                      '<button class="mb-clientnotification-button mb-clientnotification-button-secondery clientnotification-notnow">'+i18n("not_now") +'</button>'+
                      '<button class="mb-clientnotification-button mb-clientnotification-button-secondery clientnotification-deactivate">'+i18n("deactivate_notification")+'</button>'+
                    '</div>'+
                  '</div>'+
                '</div>';

              var clientnotificationElement = $(htmlContent);
              clientnotificationElement = this.applyCustomTheme(clientnotificationElement);
              $('[data-template="clientnotification"]').html(clientnotificationElement);

              this.$clientnotification = $('[data-template="clientnotification"] :first-child');

              switch (actionType) {
                case "download":
                  $('.mb-clientnotification-button-primary').on('click', this.handleClientNotificationAction.bind(this));
                  break;
                default:
                  console.warn("Only 'download' actions are supported!")
                  break;
              }
              $('.clientnotification-deactivate').on('click', this.handleCloseClick.bind(this))
              $('.clientnotification-notnow').on('click', this.handleNotNowClick.bind(this));

            }
          }.bind(this));
        },

        handleCloseClick: function(e) {
          this.clientnotificationIsOpen = false;
          this.$clientnotification.removeClass('show');
          ClientNotificationUtil.markClientNotificationAsRead(this.clientNotificationContentJson);
          this.goToNext();
          try {
            app.trigger("actionperformed", ACTION_NAME + "_close", {"application": app,
                                                        "args": app.args,
                                                        "weight": -1,
                                                        "e": e,
                                                        "comment": "ignore",
                                                        "model": {},
                                                        "handlerExists": app.handlerExists,
                                                        "returnValue": app.returnValue,
                                                        "error": app.error });
          } catch (e) {
            if (console && console.warn) console.warn("Failed to trigger actionperformed", e);
          }
        },

        handleNotNowClick: function(e) {
          this.clientnotificationIsOpen = false;
          this.$clientnotification.removeClass('show');
          ClientNotificationUtil.snoozNotification(this.clientNotificationContentJson, clientnotificationGeneralConfig.notification_snooze_time_in_hours);
          this.goToNext();
          try {
            app.trigger("actionperformed", ACTION_NAME + "_snoozed", {"application": app,
                                                        "args": app.args,
                                                        "weight": -1,
                                                        "e": e,
                                                        "comment": "Snoozed client notification",
                                                        "model": {},
                                                        "handlerExists": app.handlerExists,
                                                        "returnValue": app.returnValue,
                                                        "error": app.error });
          } catch (e) {
            if (console && console.warn) console.warn("Failed to trigger actionperformed", e);
          }
        },

        handleClientNotificationAction: function(e) {
          ClientNotificationUtil.markClientNotificationAsRead(this.clientNotificationContentJson);
          var href = this.clientNotificationContentJson.client_notification_actions[0].href;
          var customTargetInsightAppURL = this.clientNotificationContentJson.client_notification_actions[0].custom_target_insight_app_url;
          if (!customTargetInsightAppURL) {
            customTargetInsightAppURL = window.location.href;
          }
          ClientNotificationUtil.setCookie("mindbreeze-insight-app-url", customTargetInsightAppURL, 12);

          href = ClientNotificationUtil.handleHref(this.apiLocation(), href);
          var actionLink = $('<a></a>');
          actionLink.attr('href', href);
          actionLink.attr('target', '_blank');
          $(e.targetElement).append(actionLink);
          actionLink[0].click();
          actionLink.remove();
          this.$clientnotification.removeClass('show');
          this.goToNext();
          try {
            app.trigger("actionperformed", ACTION_NAME + "_download", {"application": app,
                                                        "args": app.args,
                                                        "weight": 1,
                                                        "e": e,
                                                        "comment": this.clientNotificationContentJson.client_notification_actions[0].label.en,
                                                        "model": {},
                                                        "handlerExists": app.handlerExists,
                                                        "returnValue": app.returnValue,
                                                        "error": app.error });
          } catch (e) {
            if (console && console.warn) console.warn("Failed to trigger actionperformed", e);
          }
        },

        applyCustomTheme: function (clientnotificationElement) {
          if (clientnotificationStyle) {
            clientnotificationElement.css({
              "top": clientnotificationStyle.top_position,
              "bottom": clientnotificationStyle.bottom_position,
              "left": clientnotificationStyle.left_position,
              "right": clientnotificationStyle.right_position,
              "border-left-color": clientnotificationStyle.left_border_color,
              "background-color": clientnotificationStyle.background_color,
              "color": clientnotificationStyle.preview_text_color,
              "font-size": clientnotificationStyle.preview_text_font_size
            });

            clientnotificationElement.find('.clientnotification-heading').css({
              "font-size": clientnotificationStyle.title_font_size
            });

            clientnotificationElement.find('.mb-clientnotification-button-primary').css({
              'background-color': clientnotificationStyle.ok_button_color,
              'color': clientnotificationStyle.ok_button_text_color
            });

            clientnotificationElement.find('.clientnotification-notnow').css({
              'background-color': clientnotificationStyle.not_now_button_color,
              'color': clientnotificationStyle.not_now_button_text_color,
            });

            clientnotificationElement.find('.clientnotification-deactivate').css({
              'background-color': clientnotificationStyle.deactivate_button_color,
              'color': clientnotificationStyle.deactivate_button_text_color,
            });

            clientnotificationElement.find('.mb-clientnotification-container').css({
              'max-width': clientnotificationStyle.max_width,
            });
          }
          return clientnotificationElement;
        },

        goToNext: function() {
          if (this.currIndex >= clientnotificationJsonData.length) {
            return;
          }
          var previewClientNotificationId = url.getQueryParam(window.location.search, PREVIEW_INFO_SCREEN_QUERY_PARAM_NAME);
          var timeout = DELAY_SHOW_NEXT_INFO_SCREEN;
          if (previewClientNotificationId) {
            timeout = 0;
          }

          this.currIndex++;
          var that = this;
          setTimeout(function () {
            that.appendClientNotification();
          }, timeout);
        },

        init: function (doNotRenderClientNotification) {
          Base.prototype.initialize.apply(this, arguments);
          if (doNotRenderClientNotification) {
            return;
          }
        },
      });

      return ClientNotificationTemplate;
});
